import type { UserType } from "../tracking/events";

export const GA_USER_TYPE_STORAGE_KEY = "ga_user_type";

const isUserType = (value: string | null): value is UserType =>
  value === "new_registered" || value === "existing" || value === "guest";

export const readGaUserType = (): UserType | null => {
  try {
    const value = sessionStorage.getItem(GA_USER_TYPE_STORAGE_KEY);
    return isUserType(value) ? value : null;
  } catch {
    return null;
  }
};

export const clearGaUserType = (): void => {
  try {
    sessionStorage.removeItem(GA_USER_TYPE_STORAGE_KEY);
  } catch {
    // sessionStorage may be unavailable (SSR / private mode); ignore.
  }
};

export const writeGaUserType = (value: UserType): void => {
  try {
    sessionStorage.setItem(GA_USER_TYPE_STORAGE_KEY, value);
  } catch {
    // sessionStorage failure must not block login/registration flow — analytics degrades silently.
  }
};
